namespace $.$$ {

	export class $shm_wordstat_task_list_head extends $.$shm_wordstat_task_list_head {

		controls() {
			return this.search_showed() ? [ this.Filter() ] : []
		}

	}

}
